import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { requestSubscribe } from "../Redux/actions";
import useIntercom from "use-intercom-hook";
import Swal from "sweetalert2";
import infobytes_logo from "../images/infobytes_trans.png";

function Footer(props) {

  const mystyle = {
    color: "#D10000",
    backgroundColor: "#FFD2D2",
    padding: "3px 10px",
    border: "1px solid red",
    borderRadius: "5px",
    marginTop: "5px",
  };

  useIntercom(process.env.REACT_APP_INTERCOM_APP_ID);
  const [email, setemail] = useState("");
  const [errorEmail, seterrorEmail] = useState("");
  function validateEmail() {
    let valid = false;
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      seterrorEmail("");
      valid = true;
    } else {
      seterrorEmail("Enter valid email");
      valid = false;
    }
    return valid;
  }
  function validateForm() {
    let email = validateEmail();
    return email;
  }
  function onchange(e) {
    setemail(e.target.value);
  }
  function onSubmitForm(e) {
    e.preventDefault();
    if (validateForm()) {
      props.requestSubscribe({
        data: {
          email: email,
        },
      });
    }
  }

  useEffect(() => {
    let subscribeData = props.candidate.subscribeData;
    if (subscribeData !== undefined) {
      if (subscribeData?.data?.status === "success") {
        Swal.fire(
          "Good job!",
          "Subscibed your email id successfully.",
          "success"
        );
        props.candidate.subscribeData = undefined;
        setemail("");
      } else {
        Swal.fire("Error!", "The email has already been taken.", "error");
        props.candidate.subscribeData = undefined;
        setemail("");
      }
    }
  }, [props.candidate.subscribeData]);

  function gototop() {
    window.scrollTo(0, 0);
  }

  return (
    <>
    {/* <!-- start footer--> */}
    <footer className="footer-dark p-0 position-relative bg-black-pearl-blue-dark">
        <div className="container">
            <div className="row justify-content-center pt-6 sm-pt-40px">
                {/* <!-- start footer column--> */}
                <div className="col-lg-3 col-md-4 col-sm-6 md-mb-30px text-center text-sm-start">
                    <a href="demo-application.html" className="footer-logo mb-15px d-inline-block">
                        <img src={infobytes_logo}
                            data-at2x="front/images/demo-application-logo-white@2x.png" alt="" />
                    </a>
                    <p>India's best business wise billing and inventory software</p>
                    <div
                        className="row align-items-center border border-color-transparent-white-light g-0 border-radius-4px mt-30px lg-mt-25px">
                        <div className="col-5 text-center">
                            <h3 className="text-white fw-700 mb-0">4.8</h3>
                        </div>
                        <div
                            className="col-7 border-start border-color-transparent-white-light ps-20px pe-20px pt-15px pb-15px lg-ps-15px lg-pe-15px text-center text-sm-start">
                            <div className="review-star-icon fs-14 lh-30">
                                <i className="fa-solid fa-star"></i><i className="fa-solid fa-star"></i><i
                                    className="fa-solid fa-star"></i><i className="fa-solid fa-star"></i><i
                                    className="fa-solid fa-star"></i>
                            </div>
                            <span className="d-block fs-14 text-white lh-20 fw-500">30k Reviews</span>
                        </div>
                    </div>
                </div>
                {/* <!-- end footer column--> */}
                {/* <!-- start footer column--> */}
                <div className="col-7 col-lg-3 col-md-4 col-sm-5 offset-md-0 offset-sm-1 order-5 order-md-3 xs-mb-30px">
                    <span className="d-block text-white fw-600 mb-10px">Need help?</span>
                    <span className="d-block">Call us directly?</span>
                    <a href="tel:9819991929" className="text-white fw-600 mb-15px d-inline-block">(91) 9819991929</a>
                    <span className="d-block">Need live support?</span>
                    <a href="mailto:nilesh@infobytes.com"
                        className="text-white fw-600 d-inline-block">nilesh@infobytes.com</a>
                </div>
                {/* <!-- end footer column--> */}
            </div>
            <div className="row justify-content-center align-items-center pt-5 md-pt-30px">
                <div className="col-12">
                    <div className="divider-style-03 divider-style-03-01 border-color-transparent-white-light"></div>
                </div>
                <div
                    className="col-xl-8 col-lg-9 pt-30px pb-30px fs-14 lh-26 last-paragraph-no-margin text-center order-2 order-sm-1">
                    <p>This site is protected by reCAPTCHA and the Google <a href="#"
                            className="text-decoration-line-bottom">privacy policy</a> and <a href="#"
                            className="text-decoration-line-bottom">terms of service</a> apply. You must not use this
                        website if you disagree with any of these website standard terms and conditions.</p>
                </div>
            </div>
        </div>
    </footer>
      <a
        class="scroll-top btn-hover"
        onClick={gototop}
        style={{ bottom: "100px",textDecoration:"none" }}
      >
        <i class="fa fa-chevron-up"></i>
      </a>
    </>
  );
}
const mapStateToProps = (state) => {
  return { candidate: state.candidate };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ requestSubscribe }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
